import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { useSidebar } from '../../contexts/SidebarContext';
import { useSecondarySidebar } from '../../contexts/SecondarySidebarContext';
import Sidebar from './Sidebar';
import Navbar from './Navbar';

const Layout = () => {
  const { isOpen, title, content, className, closeSidebar } = useSidebar();
  const { 
    isOpen: isSecondaryOpen, 
    title: secondaryTitle, 
    content: secondaryContent, 
    className: secondaryClassName, 
    closeSecondarySidebar: closeSecondarySidebar 
  } = useSecondarySidebar();
  
  const [isSidebarOpen, setIsSidebarOpen] = useState(window.innerWidth >= 992);
  const [isRightSidebarVisible, setIsRightSidebarVisible] = useState(false);
  const [isSecondarySidebarVisible, setIsSecondarySidebarVisible] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsSidebarOpen(window.innerWidth >= 992);
    };

    // Set initial state
    handleResize();

    // Add event listener
    window.addEventListener('resize', handleResize);

    // Cleanup
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (isOpen) {
      // Add a small delay to ensure the DOM is updated
      requestAnimationFrame(() => {
        setIsRightSidebarVisible(true);
      });
    } else {
      setIsRightSidebarVisible(false);
    }
  }, [isOpen]);

  useEffect(() => {
    if (isSecondaryOpen) {
      requestAnimationFrame(() => {
        setIsSecondarySidebarVisible(true);
      });
    } else {
      setIsSecondarySidebarVisible(false);
    }
  }, [isSecondaryOpen]);

  const toggleSidebar = () => {
    console.log('toggleSidebar');
    setIsSidebarOpen(!isSidebarOpen);
  };

  const handleCloseRightSidebar = () => {
    console.log('handleCloseRightSidebar');
    setIsRightSidebarVisible(false);
    // Add a small delay before actually closing to allow the animation to complete
    setTimeout(() => {
      closeSidebar();
    }, 300);
  };

  const handleCloseSecondarySidebar = () => {
    console.log('handleCloseSecondarySidebar');
    setIsSecondarySidebarVisible(false);
    setTimeout(() => {
      closeSecondarySidebar();
    }, 300);
  };

  return (
    <div className="app">
      <Sidebar isOpen={isSidebarOpen} onClose={toggleSidebar} />
      <div className={`main-content ${!isSidebarOpen ? 'expanded' : ''}`}>
        <Navbar 
          onSidebarToggle={toggleSidebar}
          isSidebarOpen={isSidebarOpen}
        />
        <div className="content-wrapper">
          <Outlet />
        </div>
      </div>
      {isOpen && (
        <>
          <div 
            className={`right-sidebar ${className} ${isRightSidebarVisible ? 'show' : ''}`}
            style={{ display: isOpen ? 'flex' : 'none' }}
          >
            <div className="rightbar-title">
              <h5 className="mb-0">{title}</h5>
              <button 
                className="btn btn-link p-0 ms-auto" 
                onClick={handleCloseRightSidebar}
              >
                <i className="fas fa-times"></i>
              </button>
            </div>
            <div className="rightbar-content pb-0">
              {content}
            </div>
          </div>
          <div 
            className={`rightbar-overlay ${isRightSidebarVisible ? 'show' : ''}`}
            onClick={handleCloseRightSidebar}
            style={{ display: isOpen ? 'block' : 'none' }}
          ></div>
        </>
      )}
      {isSecondaryOpen && (
        <>
          <div 
            className={`secondary-right-sidebar ${secondaryClassName} ${isSecondarySidebarVisible ? 'show' : ''}`}
            style={{ display: isSecondaryOpen ? 'flex' : 'none' }}
          >
            <div className="rightbar-title">
              <h5 className="mb-0">{secondaryTitle}</h5>
              <button 
                className="btn btn-link p-0 ms-auto" 
                onClick={handleCloseSecondarySidebar}
              >
                <i className="fas fa-times"></i>
              </button>
            </div>
            <div className="rightbar-content pb-0">
              {secondaryContent}
            </div>
          </div>
          <div 
            className={`secondary-rightbar-overlay ${isSecondarySidebarVisible ? 'show' : ''}`}
            onClick={handleCloseSecondarySidebar}
            style={{ display: isSecondaryOpen ? 'block' : 'none' }}
          ></div>
        </>
      )}
      {isSidebarOpen && window.innerWidth < 992 && (
        <div className="sidebar-backdrop" onClick={toggleSidebar}></div>
      )}
    </div>
  );
};

export default Layout; 